/* Bra Guide-advertorials (USA): gedrag voor de secties mv-gids-kop, mv-gids-artikel, mv-gids-vragen en mv-gids-slot.
   - Aftelklok naar middernacht in de tijdzone van de bezoeker ([data-gids-klok]); daarna weer 23:59:59.
   - Leesvoortgang ([data-gids-voortgang]) en de hoogte van een plakkende actiebalk (--g-balkh).
   - Datum van vandaag in [data-gids-datum], in de taal van de pagina.
   - Plakbalk ([data-gids-sticky]): op zodra [data-gids-start] in beeld schuift, weg zolang een [data-gids-aanbod]
     in beeld staat (alleen met data-gids-sticky-wijk), zodat er nooit twee dezelfde knoppen boven elkaar staan.
   - Onthullen bij binnenkomen (.g-onthul, .g-ontleed) en klantvideo's die alleen in beeld spelen (video.g-loop).
   - Maatwijzer ([data-gids-maat]): band en cup uit de maattabel van het product (metaobject), niets bedacht.
   Script mag meerdere keren geladen worden (elke sectie laadt het); het draait één keer. Opnieuw opbouwen na een
   wijziging in de theme editor via shopify:section:load. */
(function () {
  if (window.mvGids) return;
  window.mvGids = true;

  var rustig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var heeftIO = 'IntersectionObserver' in window;
  function twee(n) { return (n < 10 ? '0' : '') + n; }

  function klokken() {
    var lijst = document.querySelectorAll('[data-gids-klok]');
    if (!lijst.length) return;
    function tik() {
      var nu = new Date();
      var middernacht = new Date(nu.getFullYear(), nu.getMonth(), nu.getDate() + 1, 0, 0, 0, 0);
      var over = Math.max(0, Math.floor((middernacht - nu) / 1000));
      lijst.forEach(function (k) {
        var u = k.querySelector('[data-u]'), m = k.querySelector('[data-m]'), s = k.querySelector('[data-s]');
        if (u) u.textContent = twee(Math.floor(over / 3600));
        if (m) m.textContent = twee(Math.floor(over / 60) % 60);
        if (s) s.textContent = twee(over % 60);
      });
    }
    tik();
    if (!window.mvGidsKlok) window.mvGidsKlok = setInterval(tik, 1000);
  }

  function datums() {
    var taal = document.documentElement.lang || 'en-US';
    var tekst;
    try {
      tekst = new Date().toLocaleDateString(taal, { month: 'long', day: 'numeric', year: 'numeric' });
    } catch (e) {
      tekst = new Date().toDateString();
    }
    document.querySelectorAll('[data-gids-datum]').forEach(function (el) { el.textContent = tekst; });
  }

  function balkHoogte() {
    var balk = document.querySelector('[data-gids-balk].g-balk--plak');
    if (balk) document.documentElement.style.setProperty('--g-balkh', balk.offsetHeight + 'px');
  }

  var stickyStaat = { voorbij: false, aanbod: [] };
  function stickyBijwerken() {
    var sticky = document.querySelector('[data-gids-sticky]');
    if (!sticky) return;
    var wijk = sticky.hasAttribute('data-gids-sticky-wijk');
    sticky.classList.toggle('is-zichtbaar', stickyStaat.voorbij && !(wijk && stickyStaat.aanbod.length));
  }

  function plakbalk() {
    var sticky = document.querySelector('[data-gids-sticky]');
    if (!sticky) return;
    var start = document.querySelector('[data-gids-start]');
    if (!heeftIO || !start) {
      stickyStaat.voorbij = true;
      stickyBijwerken();
      return;
    }
    // Op zodra het eerste punt een derde van onderen in beeld komt, of al voorbij is.
    new IntersectionObserver(function (items) {
      items.forEach(function (it) {
        stickyStaat.voorbij = it.isIntersecting || it.boundingClientRect.top < 0;
      });
      stickyBijwerken();
    }, { rootMargin: '0px 0px -35% 0px' }).observe(start);
    var aanbodIO = new IntersectionObserver(function (items) {
      items.forEach(function (it) {
        stickyStaat.aanbod = stickyStaat.aanbod.filter(function (el) { return el !== it.target; });
        if (it.isIntersecting) stickyStaat.aanbod.push(it.target);
      });
      stickyBijwerken();
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('[data-gids-aanbod]').forEach(function (el) { aanbodIO.observe(el); });
  }

  function voortgang() {
    var balken = document.querySelectorAll('[data-gids-voortgang]');
    if (!balken.length) return;
    var gepland = false;
    function teken() {
      gepland = false;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var pct = (max > 0 ? window.scrollY / max : 0) * 100;
      balken.forEach(function (b) { b.style.width = pct + '%'; });
    }
    window.addEventListener('scroll', function () {
      if (gepland) return;
      gepland = true;
      requestAnimationFrame(teken);
    }, { passive: true });
    teken();
  }

  function onthullen() {
    var els = document.querySelectorAll('.g-onthul, .g-ontleed');
    if (!els.length) return;
    if (!heeftIO || rustig) {
      els.forEach(function (el) { el.classList.add('is-zicht'); });
      return;
    }
    document.querySelectorAll('.mv-gids').forEach(function (r) { r.classList.add('mv-gids--js'); });
    var io = new IntersectionObserver(function (items) {
      items.forEach(function (it) {
        if (it.isIntersecting) { it.target.classList.add('is-zicht'); io.unobserve(it.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function videos() {
    var lijst = document.querySelectorAll('video.g-loop');
    if (!lijst.length || rustig || !heeftIO) return;
    var vo = new IntersectionObserver(function (items) {
      items.forEach(function (it) {
        var v = it.target;
        if (it.isIntersecting) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.25 });
    lijst.forEach(function (v) { vo.observe(v); });
  }

  function leesJson(vak, sel) {
    var el = vak.querySelector(sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // "70=32" per regel naar { "70": "32" }
  function labelKaart(tekst) {
    var kaart = {};
    (tekst || '').split(/\r?\n/).forEach(function (r) {
      var d = r.split('=');
      if (d.length === 2 && d[0].trim()) kaart[d[0].trim()] = d[1].trim();
    });
    return kaart;
  }

  function maatwijzers() {
    document.querySelectorAll('[data-gids-maat]').forEach(function (vak) {
      if (vak.dataset.klaar) return;
      var data = leesJson(vak, '[data-gids-maat-data]');
      var band = vak.querySelector('[data-gids-band]');
      var cup = vak.querySelector('[data-gids-cup]');
      var uit = vak.querySelector('[data-gids-uit]');
      if (!data || !data.banden || !band || !cup || !uit) return;
      vak.dataset.klaar = '1';
      var zin = leesJson(vak, '[data-gids-maat-tekst]') || '[bra]: [size]';
      var mis = leesJson(vak, '[data-gids-maat-mis]') || '';
      var leeg = leesJson(vak, '[data-gids-maat-leeg]') || '';
      var bandLabel = labelKaart(leesJson(vak, '[data-gids-maat-banden]'));
      var cupLabel = labelKaart(leesJson(vak, '[data-gids-maat-cups]'));
      var perBand = {};
      var cups = [];
      data.banden.forEach(function (b) {
        perBand[b.waarde] = b;
        (b.cups || []).forEach(function (c) { if (cups.indexOf(c[0]) < 0) cups.push(c[0]); });
        band.add(new Option(bandLabel[b.waarde] || b.label || b.waarde, b.waarde));
      });
      cups.forEach(function (c) { cup.add(new Option(cupLabel[c] || c, c)); });

      function toon() {
        if (!band.value || !cup.value) { uit.textContent = leeg; return; }
        var b = perBand[band.value];
        var hit = b && (b.cups || []).filter(function (c) { return c[0] === cup.value; })[0];
        if (!hit) { uit.textContent = mis; return; }
        var bh = (bandLabel[band.value] || band.value) + (cupLabel[cup.value] || cup.value);
        var delen = zin.split('[size]');
        uit.textContent = '';
        delen.forEach(function (deel, i) {
          uit.appendChild(document.createTextNode(deel.split('[bra]').join(bh)));
          if (i < delen.length - 1) {
            var vet = document.createElement('b');
            vet.textContent = hit[1];
            uit.appendChild(vet);
          }
        });
      }
      band.addEventListener('change', toon);
      cup.addEventListener('change', toon);
    });
  }

  function start() {
    klokken();
    datums();
    balkHoogte();
    voortgang();
    plakbalk();
    onthullen();
    videos();
    maatwijzers();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('resize', balkHoogte, { passive: true });
  document.addEventListener('shopify:section:load', function () {
    klokken();
    datums();
    balkHoogte();
    onthullen();
    maatwijzers();
  });
})();
